import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { useDispatch } from 'react-redux';
import Form from 'erpcore/components/Form';
import Button from 'erpcore/components/Button';
import Svg from 'erpcore/components/Svg';
import Tooltip from 'erpcore/components/Tooltip';
import Modal from 'erpcore/components/Modal';
import { actions as entityNotificationsActions } from 'erpcore/screens/EntityNotifications/EntityNotifications.reducer';

const EntityNotificationsDelete = ({ notificationIri, handleSubmit, submitting, callback }) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);

    const handleModal = () => {
        setOpened(!opened);
    };

    const onSubmit = () => {
        return new Promise((resolve, reject) =>
            dispatch({
                promise: { resolve, reject },
                type: entityNotificationsActions.START_DELETE_ENTITY_NOTIFICATION,
                iri: notificationIri
            })
        )
            .then(() => {
                handleModal();
                callback();
            })
            .catch(error => {
                handleModal();
                return error;
            });
    };

    return (
        <Fragment>
            <Tooltip content="Delete notification">
                <button type="button" onClick={() => handleModal()}>
                    <Svg icon="remove" />
                </button>
            </Tooltip>
            <Modal
                variation="small"
                opened={opened}
                onClose={() => handleModal()}
                title="Delete notification"
                subtitle={<>Are you sure you want to delete this notification?</>}
            >
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Button submit loading={submitting} label="Delete" />
                    <Button variation="secondary" label="Cancel" onClick={() => handleModal()} />
                </Form>
            </Modal>
        </Fragment>
    );
};

EntityNotificationsDelete.defaultProps = {
    submitting: false,
    callback: () => {}
};

EntityNotificationsDelete.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    notificationIri: PropTypes.string.isRequired,
    callback: PropTypes.func
};

export default reduxForm({
    form: 'EntityNotificationsDeleteForm',
    enableReinitialize: true
})(EntityNotificationsDelete);
